import React from "react";
import { Link, useLocation } from "react-router-dom";
import SeoHead from "@/components/brand/SeoHead";
import GlowingGridBackground from "@/components/brand/GlowingGridBackground";
import GradientBorderCard from "@/components/brand/GradientBorderCard";
import FadeUp from "@/components/brand/FadeUp";

export const Placeholder = ({ pageName }) => {
    const location = useLocation();
    const name = pageName || "This Page";

    return (
        <>
            <SeoHead
                title={`${name} | Vibe for Success`}
                description={`${name} is coming in the next build phase. Vibe for Success, Inc. is a Florida nonprofit corporation.`}
                path={location.pathname}
            />
            <section
                className="vfs-section relative overflow-hidden"
                data-testid="placeholder-page"
            >
                <GlowingGridBackground accent="#8B5CF6" opacity={0.12} />
                <div className="vfs-container relative">
                    <FadeUp>
                        <GradientBorderCard radius={22}>
                            <div className="p-10 sm:p-14 lg:p-20 text-center max-w-3xl mx-auto">
                                <span className="vfs-eyebrow mb-6 inline-flex">
                                    Coming Soon
                                </span>
                                <h1
                                    className="vfs-h1 mt-4 mb-5"
                                    data-testid="placeholder-page-name"
                                >
                                    <span className="vfs-grad-text">
                                        {name}
                                    </span>
                                </h1>
                                <p
                                    className="vfs-body text-lg mb-8 max-w-xl mx-auto"
                                    style={{
                                        color: "var(--text-secondary)",
                                    }}
                                >
                                    This page is part of the next build phase
                                    and is being prepared with care. Please
                                    check back soon — or head back to the
                                    homepage to explore the rest of the site.
                                </p>
                                <Link
                                    to="/"
                                    className="vfs-cta inline-flex"
                                    data-testid="placeholder-home-link"
                                >
                                    Back to Home
                                </Link>
                            </div>
                        </GradientBorderCard>
                    </FadeUp>
                </div>
            </section>
        </>
    );
};

export default Placeholder;
